import { ContactRolesEnum } from '@/bundles/Contact/enums/contactRoles';

export const propertyContactRoles = [
  { text: 'Architect', value: ContactRolesEnum['architect'] },
  { text: 'Developer', value: ContactRolesEnum['developer'] },
  { text: 'Landlord', value: ContactRolesEnum['landlord'] },
  { text: 'Listing Agent', value: ContactRolesEnum['listing_agent'] },
  { text: 'Listing Agent - Sublease', value: ContactRolesEnum['listing_agent_-_sublease'] },
  { text: 'Owner', value: ContactRolesEnum['owner'] },
  { text: 'Property Manager', value: ContactRolesEnum['property_manager'] },
  { text: 'Structural Engineer', value: ContactRolesEnum['structural_engineer'] },
  { text: 'True Owner', value: ContactRolesEnum['true_owner'] },
];
